import { ConfirmSplaOrderComponent } from "../../../../popup-collection/confirm-spla-order/confirm-spla-order.component";

import { FileService } from "../../../../services/file.service";
import { BreadcrumbComponent } from "../../../../breadcrumb/breadcrumb.component";
import { ManageService } from "../../../../services/manage.service";
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  AnnuityDetailsViewModel,
  AnnuityItems,
  GetOrderItemList,
} from "../../../../models/annuity-details-view.model";
import { AnnuityItemsViewModel } from "../../../../models/annuity-view.model";
// tslint:disable-next-line:import-blacklist
import { Subject } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { CustomerPaymentsOutput } from "../../../../models/account-ledger.model";
import { CheckOutService } from "../../../../services/checkout.service";
import { CommonService } from "../../../../services/common.service";
import { takeUntil } from "rxjs/operators";
import { isNullOrUndefined } from "../../../../shared/tools.collections";

declare var $: any;

@Component({
  selector: "app-manage-teledetails",
  templateUrl: "./manage-teledetails.component.html",
  styleUrls: ["./manage-teledetails.component.css"],
})
export class ManageTeleSmartdetailsComponent implements OnInit, OnDestroy {
  modalDetails = {
    title: "Order Confirmation",
    content:
      "Your order is confirmed. If you have any questions, please contact your Dicker Data representative.",
  };

  searchField = "";
  searchOrder = "";
  showEndUser = true;
  showSaveBtn = false;

  details: AnnuityDetailsViewModel;
  annuityItems: AnnuityItems;
  currentItemDetails: GetOrderItemList[] = [];
  nextItemDetails: GetOrderItemList[] = [];

  newOrderItems: GetOrderItemList[] = [];
  newItemsList: AnnuityItemsViewModel[] = [];

  totalPrice = 0;

  loadContent: boolean;
  readOnly = false;
  responseMsg: any;

  // params
  programType = "TELE";
  annuityId = "";
  orderNo = "";
  orderSuffix = "";
  vendorAgreementNo = "";
  // export excel
  url: string;
  paymentMethod: CustomerPaymentsOutput = null;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild(BreadcrumbComponent) sample: BreadcrumbComponent;


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private commonService: CommonService,
    private checkOutService: CheckOutService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {

    $("#levelOne").animate({ scrollLeft: 250 }, 400);

    this.activatedRoute.paramMap.subscribe((param) => {
      this.loadContent = false;
      this.annuityId = param.get("annuityId");
      this.orderNo = param.get("orderNo");
      this.vendorAgreementNo = param.get("vendorAgreementNo");
      if (
        param.get("orderSuffix") &&
        param.get("orderSuffix") !== "OrderSuffix"
      ) {
        this.orderSuffix = param.get("orderSuffix");
      }
      this.manageService
        .getSPLADetails(this.annuityId, this.orderNo, this.orderSuffix, "")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (value: AnnuityDetailsViewModel) => {
            this.details = value;
            if (value.annuityType.detailsView == 'ReadOnlySPLADetails') { this.readOnly = true; }
            if (value.paymentNumber) {
              this.checkOutService
                .GetSubscriptionPaymentMethodList()
                .subscribe((res) => {
                  if (res) {
                    this.paymentMethod = res.find(
                      (m) => m.out_customer_number === value.paymentNumber
                    );
                  }
                });
            }

            //this.manageService.monitorSPLADetailsChange(value);
            this.manageService.monitorCurrentPaymentDetails({
              purchaseAccess: value.puchaseAccess,
              digitalWalletId: value.paymentNumber
            });

            if (!isNullOrUndefined(value)) {
              this.manageService.currentPendingSpla.subscribe(
                (val) => {
                  this.getAnnuityItems();
                },
                (error: any) => {
                  console.error(error);
                  this.loadContent = true;
                }
              );
            } else {
              this.loadContent = true;
            }
          },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          }
        );
      // this.activatedRoute.parent.paramMap.subscribe((pram) => {
      //   this.programType = pram.get("programType");
      //   this.programName = pram.get("programName");
      // });
      // if (this.router.url.includes("ReadOnlySPLADetails")) {
      //   this.readOnly = true;
      // }
    });

    this.manageService.currentBillingInfo
    .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        if (value) {
          this.manageService
            .getSPLADetails(this.annuityId, this.orderNo, this.orderSuffix, "")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((value: AnnuityDetailsViewModel) => {
              this.paymentMethod = null;
              if (value.paymentNumber) {
                this.checkOutService
                  .GetSubscriptionPaymentMethodList()
                  .subscribe((res) => {
                    if (res) {
                      this.paymentMethod = res.find(
                        (m) => m.out_customer_number === value.paymentNumber
                      );
                    }
                  });
              }
              //this.manageService.monitorSPLADetailsChange(value);
            });
        }
      });
  }

  getAnnuityItems(): void {
    this.manageService
      .getAnnuityItems(
        this.details.nextOrderNo,
        this.details.nextOrderSuffix,
        this.details.currOrderNo,
        this.details.currOrderSuffix,
        this.details.accountId
      )
      .subscribe(
        (val: AnnuityItems) => {
          this.annuityItems = val;
          this.currentItemDetails = val.currentItemDetails;
          if (val.nextItemDetails) {
            this.nextItemDetails = val.nextItemDetails;
            this.nextItemDetails.forEach(
              (i) =>
                (i.currentQty =
                  this.currentItemDetails.filter(
                    (c) => c.out_line_seq === i.out_line_seq
                  ).length > 0
                    ? this.currentItemDetails.filter(
                      (c) => c.out_line_seq === i.out_line_seq
                    )[0].out_line_qty
                    : "0")
            );
            this.nextItemDetails = this.nextItemDetails.filter(
              (x) => x.out_stock_code !== "" && x.out_stock_code !== "Note"
            );
          }
          this.calculateTotalPrice();
          this.loadContent = true;
        },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
      );
  }

  // downloadPriceFile(stocktypecode: string): void {
  //   this.loadContent = false;
  //   this.manageService.exportAnnuitySKUPriceList(stocktypecode).subscribe(
  //     (data: any) => {
  //       const fileName = `${this.programName}_StockCodes.xlsx`;
  //       this.fileService.saveAsExcelFile(data, fileName);
  //       this.loadContent = true;
  //     },
  //     (error: any) => {
  //       console.error(error);
  //       this.loadContent = true;
  //     }
  //   );
  // }

  getItemsList(): void {
    this.searchOrder = "";
    this.loadContent = false;
    this.manageService
      .getItemList(
        this.annuityId,
        this.programType,
        this.orderNo,
        this.orderSuffix
      )
      .subscribe(
        (values: AnnuityItemsViewModel[]) => {
          this.newItemsList = values;
          this.loadContent = true;
        },
        (error: any) => {
          this.loadContent = true;
          console.error(error);
        }
      );
  }

  getSubscriptionList(): void {
    this.router.navigate(["AddTELESubscriptions"], {
      relativeTo: this.activatedRoute,
    });
  }

  updateAnnuityItem(
    stockCode: string,
    lineSequence: string,
    qty: string
  ): void {
    this.loadContent = false;
    this.manageService
      .addAnnuityItem(
        stockCode,
        this.annuityItems.orderNo,
        this.annuityItems.orderSuffix,
        this.annuityId,
        lineSequence,
        qty
      )
      .subscribe(
        (value: any) => {
          this.responseMsg = value.responseMessage;

          if (qty === "0") {
            this.commonService.implementToast(
              `Stock Code : ${stockCode} Removed Successfully`,
              "Success"
            );
            this.getAnnuityItems();
          } else {
            this.commonService.implementToast(this.responseMsg, "Success");
          }
          this.loadContent = true;
        },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
      );
  }

  onQtyChange(item: GetOrderItemList, qty: string, idx: number): void {
    if (this.programType == 'SPLA' || this.programType == 'CITRIXCSP') {
      if (qty != null && qty !== "") {
        this.updateAnnuityItem(item.out_stock_code, item.out_line_seq, qty);
        this.nextItemDetails[idx].out_line_qty = qty;
        // tslint:disable-next-line:radix
        this.nextItemDetails[idx].out_line_amount_ex = (
          parseFloat(item.out_line_price) * parseInt(qty)
        ).toString();
        this.calculateTotalPrice();
      } else {
        this.commonService.implementToast("Qty must be greater than 0", "Error");
      }
    } else {
      if (qty != null && qty !== "" && qty !== "0") {
        this.updateAnnuityItem(item.out_stock_code, item.out_line_seq, qty);
        this.nextItemDetails[idx].out_line_qty = qty;
        // tslint:disable-next-line:radix
        this.nextItemDetails[idx].out_line_amount_ex = (
          parseFloat(item.out_line_price) * parseInt(qty)
        ).toString();
        this.calculateTotalPrice();
      } else {
        this.commonService.implementToast("Qty must be greater than 0", "Error");
      }
    }
    // if (qty != null && qty !== "" && qty !== "0") {
    //   this.updateAnnuityItem(item.out_stock_code, item.out_line_seq, qty);
    //   this.nextItemDetails[idx].out_line_qty = qty;
    //   // tslint:disable-next-line:radix
    //   this.nextItemDetails[idx].out_line_amount_ex = (
    //     parseFloat(item.out_line_price) * parseInt(qty)
    //   ).toString();
    //   this.calculateTotalPrice();
    // } else {
    //   this.commonService.implementToast("Qty must be greater than 0", "Error");
    // }
  }

  increaseDecreaseQty(item: GetOrderItemList, idx: number, type: string): void {
    // tslint:disable-next-line:radix
    let qty = parseInt(item.out_line_qty);
    if (qty >= 0) {
      if (type === "increase") {
        qty++;
      } else {
        qty--;
      }
      const strQty = qty.toString();
      this.onQtyChange(item, strQty, idx);
    }
  }

  confirmAnnuity(): void {
    if (!this.details.nextCustomerRef) {
      this.commonService.implementToast(
        "Customer Reference cannot be blank",
        "Error"
      );
      return;
    }
    this.loadContent = false;
    this.manageService
      .confirmAnnuityOrder(
        this.annuityId,
        this.orderNo,
        this.orderSuffix,
        this.details.nextCustomerRef
      )
      .subscribe(
        (val: any) => {
          if (val.status === false) {
            // this.commonService.showValidator('#btnConfirm','Error confirming your order. Please try again', 'right', 'error');
            this.commonService.implementToast(
              "Error confirming your order. Please try again",
              "Error"
            );
          } else {
            $("#myModal").appendTo("body").modal("show");
          }
          this.loadContent = true;
        },
        (error: any) => {
          console.error(error);
          // this.commonService.showValidator('#btnConfirm','Error confirming your order. Please try again', 'right', 'error');
          this.commonService.implementToast(
            "Error confirming your order. Please try again",
            "Error"
          );
          this.loadContent = true;
        }
      );
  }

  saveEndUser(item: GetOrderItemList, idx: number): void {
    this.loadContent = false;
    item.needUpdate = false;
    this.manageService
      .saveLineEndUser(
        this.orderNo,
        this.orderSuffix,
        item.out_display_name,
        item.out_line_seq
      )
      .subscribe(
        (val: string) => {
          if (val === "Success") {
            this.commonService.implementToast(
              "Successfully saved end user name",
              "Success"
            );
          } else {
            this.commonService.implementToast(val, "Error");
          }
          this.loadContent = true;
        },
        (error: any) => {
          this.loadContent = true;
          console.error(error);
        }
      );
  }

  onEndUserChange(item: GetOrderItemList): void {
    item.needUpdate = true;
  }

  calculateTotalPrice(): void {
    let total = 0;
    this.nextItemDetails.forEach(
      (i) => (total += parseFloat(i.out_line_amount_ex))
    );
    this.totalPrice = total;
  }

  removeCurrentItem(item: GetOrderItemList): void {
    const dialogRef = this.dialog.open(ConfirmSplaOrderComponent, {
      width: "600px",
      data: { item: item },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateAnnuityItem(item.out_stock_code, item.out_line_seq, "0");
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    this.router.navigateByUrl(
      `/manageSubscriptions/${this.programType}`
    );
    $("#levelOne").animate({ scrollLeft: 0 }, 400);
  }

  onNavigate(url) {
    window.open(url, "_blank");
  }
}
